import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

const MemberList = ({ members, loading, onSelect }) => {
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100 flex-column w-100">
                <Spinner color="primary" />
                <p className="mt-3 text-muted">Carregando alunos...</p>
            </div>
        );
    }

    if (members.length === 0) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100 flex-column w-100 text-center px-4">
                <i className="mdi mdi-account-search-outline text-muted mb-3" style={{ fontSize: "64px", opacity: 0.5 }}></i>
                <h5 className="text-secondary fw-semibold">Nenhum aluno encontrado</h5>
                <p className="text-muted small">Tente buscar por outro nome usando o teclado.</p>
            </div>
        );
    }

    return (
        <div className="w-100 pb-3">
            {members.map((member, index) => (
                <div 
                    key={member.id} 
                    className="kiosk-member-row d-flex align-items-center gap-3 px-4 py-3"
                    onClick={() => onSelect?.(member)}
                    style={{ 
                        cursor: "pointer", 
                        transition: "background-color 0.2s ease, transform 0.1s ease-in-out",
                        borderBottom: index < members.length - 1 ? "1px solid rgba(0, 0, 0, 0.04)" : "none"
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.03)"}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                    onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.98)"}
                    onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
                    onTouchStart={(e) => { e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)"; e.currentTarget.style.transform = "scale(0.98)"; }}
                    onTouchEnd={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.transform = "scale(1)"; }}
                >
                    {/* Avatar */}
                    <div 
                        className="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{ 
                            width: "72px", 
                            height: "72px",
                            border: "3px solid rgba(255, 255, 255, 0.8)",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)" 
                        }}
                    >
                        {member.photoUrl || member.photo ? (
                            <img src={member.photoUrl || member.photo} alt={member.fullName} className="rounded-circle w-100 h-100" style={{ objectFit: "cover" }} />
                        ) : (
                            <span className="text-primary h2 mb-0 fw-bold">
                                {(member.fullName || "?").charAt(0).toUpperCase()}
                            </span>
                        )}
                    </div>

                    {/* Dados */}
                    <div className="flex-grow-1 overflow-hidden text-start ms-2">
                        <h4 className="fw-bold mb-1 ellipsis-text text-dark" style={{ letterSpacing: "-0.5px" }}>
                            {member.fullName || "Membro"}
                        </h4>
                        {member.memberNumber && (
                            <span className="text-muted font-size-18 d-flex align-items-center">
                                <i className="mdi mdi-card-account-details-outline me-2"></i>
                                {member.memberNumber}
                            </span>
                        )}
                    </div>

                    {/* Ação / Ícone */}
                    <div className="flex-shrink-0 ms-3">
                        <div 
                            className="d-flex align-items-center justify-content-center rounded-circle" 
                            style={{ 
                                width: "48px", 
                                height: "48px",
                                backgroundColor: "rgba(255, 255, 255, 0.5)",
                                border: "1px solid rgba(0,0,0,0.05)"
                            }}
                        >
                            <i className="mdi mdi-arrow-right text-primary font-size-24"></i>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

MemberList.propTypes = {
    members: PropTypes.array,
    loading: PropTypes.bool,
    onSelect: PropTypes.func
};

export default MemberList;
